
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  useEffect(() => {
    // Log the 404 error
    console.error(
      "404 Error: User attempted to access non-existent route:",
      pathname
    );

    // Check if this is a deep link that needs redirection
    if (pathname.includes('/group/') || 
        pathname.includes('/invite/') || 
        pathname.includes('/app') || 
        pathname.includes('/settings/')) {
      
      // Extract the actual path without any potential hash or search params
      const cleanPath = pathname.split('?')[0].split('#')[0];
      
      // If we're on sakuwari.jp, handle the redirect immediately
      if (window.location.hostname === 'sakuwari.jp') {
        console.log('Redirecting on sakuwari.jp to:', cleanPath);
        
        // For production domain - critical fix for refresh issues
        // Force a complete URL replacement with hash
        window.location.replace('/#' + cleanPath);
        return;
      } else {
        // On other domains, use React Router navigation
        try {
          navigate(cleanPath);
        } catch (e) {
          console.error('Navigation failed:', e);
          navigate('/');
        }
      }
    }
  }, [pathname, navigate]);

  // Determine if this is the production domain
  const isProdDomain = window.location.hostname === 'sakuwari.jp';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-6 max-w-md">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        
        {isProdDomain && (
          <div className="mb-4 text-amber-600">
            <p className="animate-pulse">Redirecting you to the correct page...</p>
          </div>
        )}
        
        <a 
          href={isProdDomain ? '/#' + pathname : '/'} 
          className="text-blue-500 hover:text-blue-700 underline"
        >
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
